var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('div',[_c('navi'),_c('router-view',{staticClass:"main_contents",style:({minHeight: _vm.footer_height}),attrs:{"id":"MAIN_CON"}}),_c('foot')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }